import { z } from 'zod';

export const loginSchema = z.object({
  email: z
    .string()
    .min(1, { message: 'login.error.emailRequired' })
    .email({ message: 'login.error.invalidEmail' }),
  password: z
    .string()
    .min(1, { message: 'login.error.passwordRequired' }),
  rememberMe: z.boolean().default(false),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
